export const bchParam = {
    subUnits: 100000000,
};
//# sourceMappingURL=chain.js.map